var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-center justify-center h-100"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"64"}}),_c('div',{staticClass:"loading-text mt-4"},[_vm._v(" "+_vm._s(_vm.loadingText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }